<template>
  <zl-dialog class="zl-saas voucher-common-dialog" title="查看凭证" ref="dialog" width="1200px" :close-on-click-modal="false">
    <div class="common-btns">
      <el-button icon="iconfont icon-xiazai" type="primary" @click="downloadArrivalOrder">下载</el-button>
      <el-button icon="el-icon-printer" type="primary" @click="printFun">打印</el-button>
    </div>
    <div class="common-content">
      <zsPdf
        v-if="src"
        :src="src"
      />
    </div>
    <div style="display:none;">
      <pdf
        ref="pdf"
        :src="src">
      </pdf>
    </div>
  </zl-dialog>
</template>
<script>
import store from '@/store'
import zsPdf from '../zsPdf.vue'
import config from '@/config/config'
import pdf from 'vue-pdf'
export default {
  components: {
    pdf,
    zsPdf
  },
  data() {
    return {
      src: '' // 预览PDF的url
    }
  },
  methods: {
    printFun() {
      this.$refs.pdf.print()
    },
    async previewElectronicOrder() {
      let fileId
      await store.dispatch(`${this.system === 'purchaser' ? 'downloadArrivalOrderCert' : 'downloadArrivalOrderCertGys'}`, {
        subOrderId: this.subOrderId
      })
        .then(res => {
          fileId = res
        })
      const result = await this._util.getFileToken(2, 1, fileId)
      this.src = `${config.fileDownUrl}/zsj-file-server/token/downloadFile?guid=${fileId}&token=${result}`
    },
    downloadArrivalOrder() {
      window.open(this.src)
    },
    async open(args) {
      this.subOrderId = args.subOrderId
      this.system = args.system
      await this.previewElectronicOrder()
      return this.$refs.dialog.open()
    },
    cancel() {
      this.$refs.dialog.cancel()
    }
  }
}
</script>
<style lang="scss">
@import '@/assets/css/voucher.scss';
</style>
